"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
/**
 * This is just a regular function that creates a React component that
 * wraps the InputComponent passed as an argument.
 *
 * @param InputComponent - React component `InputComponent` (any input based component like: Input, FormInput, SearchBar)
 */
function inputEnterAction(InputComponent) {
    var _a;
    // Creating a runtime component class
    return _a = /** @class */ (function (_super) {
            tslib_1.__extends(class_1, _super);
            function class_1() {
                var _this = _super !== null && _super.apply(this, arguments) || this;
                // keydown event handler to handle all keyboard events
                // for the <InputComponent />.
                _this.onKeyDown = function (e) {
                    var _a = _this.props, onKeyDown = _a.onKeyDown, onEnter = _a.onEnter, triggerOnEmpty = _a.triggerOnEmpty, enterKeyCode = _a.enterKeyCode;
                    // triggers the original `onKeyDown` event if defined
                    onKeyDown && onKeyDown(e);
                    // triggers the `onEnter` callback when the user press
                    // enter key inside the input.
                    if (e.which === enterKeyCode && (triggerOnEmpty || (!triggerOnEmpty && e.target.value))) {
                        onEnter(e);
                    }
                };
                return _this;
            }
            class_1.prototype.render = function () {
                var _a = this.props, onKeyDown = _a.onKeyDown, onEnter = _a.onEnter, triggerOnEmpty = _a.triggerOnEmpty, enterKeyCode = _a.enterKeyCode, others = tslib_1.__rest(_a, ["onKeyDown", "onEnter", "triggerOnEmpty", "enterKeyCode"]);
                // Create the InputComponent with onKeyDown handler
                // that listen to `enter` key press.
                return (React.createElement(InputComponent, tslib_1.__assign({ onKeyDown: this.onKeyDown }, others)));
            };
            return class_1;
        }(React.Component)),
        _a.defaultProps = {
            enterKeyCode: 13
        },
        _a;
}
exports.default = inputEnterAction;
